'use client';

import { useLayoutEffect } from 'react';

import { useCookieConsent } from './cookie-consent-context';

/**
 * Render inside a layout to suppress the cookie consent banner.
 * Used for jurisdictions that do not require cookie consent (e.g. za-popia).
 * Uses useLayoutEffect to set the exemption ref before the parent's
 * useEffect decides whether to show the banner.
 * Renders no DOM elements.
 */
export function CookieConsentExemption() {
  const { exempt } = useCookieConsent();

  useLayoutEffect(() => {
    exempt();
  }, [exempt]);

  return null;
}
